import { theme, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import { alertStatusFaqContent } from "./statusFaqContent"

import styles from "./AlertStatusInfo.module.less"

const { Text } = Typography

export const AlertStatusInfo = ({ status, credit_request_id = null }) => {
  const { isAdmin } = useSelector((state) => state.auth)
  const { t } = useTranslation()
  const { token } = theme.useToken()

  const content = alertStatusFaqContent?.[status]

  let link = content?.link
  if (link === "open_credit_request") {
    if (credit_request_id) {
      link = isAdmin
        ? `${window.location.origin}/requests/credits?open_credit=${credit_request_id}`
        : `${window.location.origin}/credits?open_credit_details=${credit_request_id}`
    } else {
      link = null
    }
  }

  if (!content?.text) return null

  return (
    <div className={styles.alertStatusInfo}>
      <Text>{t(content.text) + " "}</Text>
      {link && (
        <ButtonComponent
          size="small"
          type="link"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          text={t(content.linkText)}
          className={styles.linkButton}
        />
      )}
    </div>
  )
}

export default AlertStatusInfo
